import { Pencil } from "lucide-react";

export const formatDate = (date: Date | null) => {
  if (!date) return "-";

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const darkenColor = (hex: string, percent: number = 30) => {
  const num = parseInt(hex.replace("#", ""), 16);

  const r = Math.max(0, (num >> 16) - (255 * percent) / 100);
  const g = Math.max(0, ((num >> 8) & 0x00ff) - (255 * percent) / 100);
  const b = Math.max(0, (num & 0x0000ff) - (255 * percent) / 100);

  return `rgb(${r}, ${g}, ${b})`;
};

const fileIconMap: { [extension: string]: string } = {
  doc: "https://w7.pngwing.com/pngs/89/291/png-transparent-microsoft-word-logo-microsoft-word-office-open-xml-document-computer-icons-computer-file-word-file-icon-blue-angle-text-thumbnail.png",
  docx: "https://w7.pngwing.com/pngs/89/291/png-transparent-microsoft-word-logo-microsoft-word-office-open-xml-document-computer-icons-computer-file-word-file-icon-blue-angle-text-thumbnail.png",
  docs: "https://w7.pngwing.com/pngs/89/291/png-transparent-microsoft-word-logo-microsoft-word-office-open-xml-document-computer-icons-computer-file-word-file-icon-blue-angle-text-thumbnail.png",

  xls: "https://cdn-icons-png.flaticon.com/512/732/732220.png",
  xlsx: "https://cdn-icons-png.flaticon.com/512/732/732220.png",
};

const defaultIcon =
  "https://cdn4.iconfinder.com/data/icons/essentials-72/24/007_-_File-512.png";

export const getFileIcon = (path: string) => {
  const match = path.match(/\.(\w+)$/i);

  if (match) {
    const ext = match[1].toLowerCase();
    return fileIconMap[ext] || defaultIcon;
  }

  return defaultIcon;
};

const getFileType = (fileName?: string) => {
  if (!fileName) return "";

  return fileName.split(".").pop()?.toLowerCase() || "";
};

export const renderFilePreview = (
  file: File | string | null,
  fileName: string | undefined,
  onChange: any,
) => {
  if (!file) return null;

  const url = file instanceof File ? URL.createObjectURL(file) : file;

  const ext = getFileType(fileName || url);

  const isImage = ["jpg", "jpeg", "png", "webp"].includes(ext);

  const isPdf = ext === "pdf";

  return (
    <div>
      {isImage && (
        <div className="image-preview-wrapper">
          <img src={url} alt="Audit preview" className="file-preview-image" />

          <label className="image-edit-overlay btn btn-badge text-main-color px-3 mb-0">
            <Pencil size={16} />

            <input type="file" hidden name="file" onChange={onChange} />
          </label>
        </div>
      )}

      {isPdf && (
        <div className="position-relative">
          <iframe
            src={url}
            title="PDF Preview"
            style={{
              width: "100%",
              height: "300px",
              border: "none",
              borderRadius: "12px",
              background: "#fff",
            }}
          />

          <label className="image-edit-overlay btn btn-badge text-main-color px-3 mb-0">
            <Pencil size={16} />

            <input type="file" hidden name="file" onChange={onChange} />
          </label>
        </div>
      )}

      {!isImage && !isPdf && (
        <div className="image-preview-wrapper">
          <img
            src={getFileIcon(fileName || "")}
            alt="Audit preview"
            className="file-preview-image"
          />

          <label className="image-edit-overlay btn btn-badge text-main-color px-3 mb-0">
            <Pencil size={16} />

            <input type="file" hidden name="file" onChange={onChange} />
          </label>
        </div>
      )}
    </div>
  );
};

export const renderExistingFilePreview = (
  documentUrl: string | null | undefined,
  onChange: any,
) => {
  if (!documentUrl) return null;


  const cleanPath = documentUrl.replace(/\\/g, "/");


  const url = `${process.env.REACT_APP_Url}/${cleanPath}`;


  // get extension from documentUrl
  const ext = cleanPath
    .split("?")[0]
    .split(".")
    .pop()
    ?.toLowerCase();


  const isImage = [
    "jpg",
    "jpeg",
    "png",
    "webp",
  ].includes(ext || "");


  const isPdf = ext === "pdf";


  return (
    <div>


      {isImage && (

        <div className="image-preview-wrapper">

          <img
            src={url}
            alt="preview"
            className="file-preview-image"
          />


          <label className="image-edit-overlay btn btn-badge text-main-color px-3 mb-0">

            <Pencil size={16}/>

            <input
              hidden
              type="file"
              name="file"
              onChange={onChange}
            />

          </label>

        </div>

      )}



      {isPdf && (

        <div className="position-relative">

          <iframe
            src={url}
            title="PDF Preview"
            style={{
              width:"100%",
              height:"300px",
              border:"none",
              borderRadius:"12px",
            }}
          />


          <label className="image-edit-overlay btn btn-badge text-main-color px-3 mb-0">

            <Pencil size={16}/>

            <input
              hidden
              type="file"
              name="file"
              onChange={onChange}
            />

          </label>

        </div>

      )}



      {!isImage && !isPdf && (

        <div className="image-preview-wrapper">

          <img
            src={getFileIcon(cleanPath)}
            alt="file"
            className="file-preview-image"
          />


          <label className="image-edit-overlay btn btn-badge text-main-color px-3 mb-0">

            <Pencil size={16}/>

            <input
              hidden
              type="file"
              name="file"
              onChange={onChange}
            />

          </label>

        </div>

      )}

    </div>
  );
};
